import { memo, useEffect } from "react";
import { Button, Checkbox, Popconfirm, Space, Table, TableProps, Tag } from "antd";
import { useTranslation } from "react-i18next";
import { mdlTablePagination } from "../../../models/ui-models/TablePagination";
import { QuestionCircleOutlined } from '@ant-design/icons';
import { mdlHotelRoomType } from "../../../models/domain/HotelRoomType";
import { HotelSelect } from "../../common/HotelSelect";

export type RoomTypeTableProps = {
    fnSelectAll?: any;
    onActiveItemSelect?: any;
    onTableItemSelect?: any;
    tableItems?: mdlHotelRoomType[];
    onDelete?: Function;
    onEdit?: Function;
    pagination: mdlTablePagination;
    onTableParamsChange?: Function;
    selectedRoomList?: string[];
    selectedRoomTypeList?: string[];
    selectedHotel?:string;
    onHotelSelect?: Function;
}

export const RoomTypeTable = memo(function RoomTypeTable(props: RoomTypeTableProps) {
    const { t } = useTranslation();

    useEffect(() => {
    }, [props]);


    const checkList = (id:string) => {
        return (props.selectedRoomTypeList?.find(x => x==id) != undefined) as boolean;
    }
    const columns: TableProps<mdlHotelRoomType>['columns'] = [
        {
            title: <>
                <Checkbox onClick={props.fnSelectAll} checked={props.selectedRoomTypeList?.length == props.tableItems?.length}></Checkbox>
            </>,
            key: 'check',
            width:30,
            render: (_, record) => (
                <Space size="middle">
                    <Checkbox onChange={props.onTableItemSelect} checked={checkList(record.id)} value={record.id}></Checkbox>
                </Space>
            ),
        },
        {
            title: t("definitions.hotels.name"),
            dataIndex: 'name',
            key: 'name'
        },
        {
            title: t("common.actions"),
            key: 'action',
            render: (_, record) => (
                <Space size="middle">
                    <Popconfirm
                        title={t("common.deleteWarning")}
                        description={t("common.deleteDescription")}
                        okText={t("common.okConfirm")}
                        cancelText={t("common.cancelConfirm")}
                        icon={<QuestionCircleOutlined style={{ color: 'red' }} />}
                        onConfirm={() => props.onDelete ? props.onDelete(record.id) : undefined}
                    >
                        <Button type="primary" danger>
                            {t("common.delete")}
                        </Button>
                    </Popconfirm>

                </Space>
            ),
        },
    ];

    const handleTableChange: TableProps<mdlHotelRoomType>['onChange'] = (pagination, filters, sorter) => {
        props.onTableParamsChange && props.onTableParamsChange(pagination, filters);
    }

    return (
        <>
        <div className="row">
            <div className="col-sm-12 mb-4">
                <HotelSelect onChange={props.onHotelSelect} defaultValue={props.selectedHotel} />
            </div>
            {
                props.tableItems
                &&
                <div className="col-sm-12">
                    <Table<mdlHotelRoomType>
                        onChange={handleTableChange}
                        size="middle"
                        columns={columns}
                        pagination={props.pagination}
                        scroll={{ x: 'max-content' }}
                        dataSource={props.tableItems.map((data: mdlHotelRoomType, index: number) => ({ ...data, key: index }))}
                    />
                </div>
            }
        </div>
        </>
    )
})